export default __webpack_public_path__ + "static/media/videocomingsoon.6731b600.webp";